import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface CTAButtonProps {
  label?: string;
  className?: string;
  /** Por defecto va al checkout. Pasar un ancla (#oferta) para hacer scroll interno. */
  href?: string;
  variant?: 'gold' | 'charcoal' | 'outline';
  showArrow?: boolean;
  size?: 'md' | 'lg';
}

/** Checkout oficial y único del Sistema IA para Nutricionistas. */
export const CHECKOUT_URL = 'https://sistema-ia-para-nutricionistas.impultienda.ar/checkout';
export function CTAButton({
  label = 'Quiero el Sistema IA para Nutricionistas',
  className = '',
  href = CHECKOUT_URL,
  variant = 'gold',
  showArrow = true,
  size = 'md'
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const handleClick = () => {
    if (goesToCheckout) trackInitiateCheckout();
  };
  const palette = {
    gold: 'bg-gold text-charcoal ring-1 ring-gold-deep/50 hover:bg-gold-soft focus-visible:ring-gold/50',
    charcoal: 'bg-charcoal text-ivory ring-1 ring-charcoal hover:bg-charcoal-soft focus-visible:ring-gold/60',
    outline: 'bg-transparent text-charcoal ring-1 ring-charcoal/25 hover:ring-charcoal/60 focus-visible:ring-gold/50'
  }[variant];
  const dimensions = size === 'lg' ? 'min-h-[60px] px-7 py-4 text-[0.86rem] sm:px-9 sm:text-[0.98rem]' : 'min-h-[52px] px-6 py-3.5 text-[0.8rem] sm:text-[0.88rem]';
  return <a href={href} onClick={handleClick} className={cn('group inline-flex items-center justify-center gap-2.5 rounded-full text-center font-sans font-bold uppercase leading-tight tracking-[0.06em] shadow-[0_12px_28px_-14px_rgba(34,34,34,0.35)] transition-[transform,background-color,box-shadow,ring] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-[0_18px_34px_-16px_rgba(34,34,34,0.4)] focus:outline-none focus-visible:ring-4', dimensions, palette, className)} data-id="element-44" data-mp="1w9cgkfwpvj0r">
      {label}
      {showArrow && <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden data-id="element-45" data-mp="1q73dzn1r0cd4" />}
    </a>;
}